import { render, staticRenderFns } from "./ConnectNetworkRouterView.vue?vue&type=template&id=70b87667&"
import script from "./ConnectNetworkRouterView.vue?vue&type=script&lang=js&"
export * from "./ConnectNetworkRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports